import { decimal, integer, minLength, maxLength, minValue, maxValue, url } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

const methods = {
	// ======================== Наша валидация ========================
	rusLatin: {
		title: 'Буквы',
		descr: 'кириллические и латинские',
		func: (value) => /^[А-ЯЁA-Z]*$/iu.test(value),
		errTextGetter: () => 'Допустимы только буквы (кириллические и латинские)',
	},
	rusLatinNum: {
		title: 'Буквы и цифры',
		descr: 'буквы кириллические и латинские',
		func: (value) => /^[А-ЯЁA-Z0-9]*$/iu.test(value),
		errTextGetter: () => 'Допустимы только цифры и буквы (кириллические и латинские)',
	},
	rusLatinEmail: {
		// просто email удалена отсюда и из метаданных в связи с CWP-21876
		title: 'Email (поддержка кириллицы)',
		descr: '',
		func: (value) => !value || /.+@.+/u.test(value),
		errTextGetter: () => 'Введите валидный email',
	},
	login: {
		title: 'Логин',
		descr: 'Для регистрации пользователей. Все символы, не менее 3 символов, кроме пробелов в начале и в конце',
		func: (value) => !value || /^[^\s].{1,}[^\s]$/iu.test(value),
		errTextGetter: () => 'Логин должен быть > 3 символов, допустимы все символы, кроме пробелов в начале и в конце',
	},
	cropSpace: {
		title: 'Чистый текст от 1 символа',
		descr: 'Не допускаются пробелы в начале и конце текста',
		func: (value) => !value || !(value.startsWith(' ') || value.endsWith(' ')),
		errTextGetter: () => 'Недопустимы пробелы в начале и в конце',
	},
	doubleSpace: {
		title: 'Запрет задвоенных пробелов',
		descr: 'Не допускаются двойные пробелы',
		func: (value) => !value || !/(\s{2,})/iu.test(value),
		errTextGetter: () => 'Недопустимы задвоенные пробелы',
	},
	numericFloatTail4: {
		title: 'Не более 4 знаков после запятой, максимально 17 знаков',
		descr: '',
		func: (value) => !value || (value.toString().length <= 17 && /^\d{1,17}(?:\.\d{1,4})?$/u.test(value)),
		is_number: true,
		errTextGetter: () => 'Не более 4 знаков после запятой, максимально 17 знаков',
	},
	etzp_link: {
		title: 'Ссылка ЭТЗП',
		descr: 'Ссылка на документы в карточке ЭТЗП',
		func: (value) => !value || value.indexOf('223.rts-tender.ru/customer/lk') === -1,
		errTextGetter: () => 'Некорректная ссылка! Необходимо указать ссылку на процедуру в открытой части',
	},
	time: {
		title: 'Время',
		descr: 'Формат ЧЧ:ММ',
		func: (value) => !value || /^(?:0[0-9]|1[0-9]|2[0123])[:](?:[0-5][0-9])$/u.test(value),
		mask: { alias: 'datetime', inputFormat: 'HH:MM' },
		errTextGetter: () => 'Формат ЧЧ:ММ',
	},
	numberPhonePlus: {
		title: 'Номер телефона',
		descr: 'Формат + и от 11 до 13 цифр после',
		func: (value) => !value || /^\+\d{11,13}$/u.test(value),
		placeholder: '+',
		mask: '+99999999999[9][9]',
		errTextGetter: () => 'Введите от 11 до 13 цифр после знака +',
	},

	// ============================================ vuelidate-валидация ==================================================
	decimal: {
		title: 'Цифры любые',
		func: decimal,
		is_number: true,
		descr: 'с плавающей точкой (не запятой!) и целые',
		errTextGetter: () => 'Введите числовое значение',
	},
	integer: {
		title: 'Цифры целые',
		func: integer,
		is_number: true,
		descr: '',
		errTextGetter: () => 'Введите целочисленное значение',
	},
	minLength: {
		title: 'Мин. длина',
		descr: 'для строк' /*и массивов*/,
		func: minLength,
		paramEditType: 'int',
		errTextGetter: (params) => `Введите значение длиной от ${params.min}`,
	},
	maxLength: {
		title: 'Макс. длина',
		descr: 'для строк' /*и массивов*/,
		func: maxLength,
		paramEditType: 'int',
		errTextGetter: (params) => `Введите значение длиной до ${params.max}`,
	},
	minValue: {
		title: 'Мин. значение',
		descr: 'для чисел и дат',
		func: minValue,
		is_number: true,
		paramEditType: 'numOrDate',
		errTextGetter: (params) => `Введите значение от ${params.min}`,
	},
	maxValue: {
		title: 'Макс. значение',
		descr: 'для чисел и дат',
		func: maxValue,
		is_number: true,
		paramEditType: 'numOrDate',
		errTextGetter: (params) => `Введите значение до ${params.max}`,
	},
	url: {
		title: 'URL',
		descr: '',
		func: url,
		errTextGetter: () => 'Введите валидный URL',
	},
	snils: {
		title: 'СНИЛС',
		descr: '',
		func: (valueInit) => {
			if (!valueInit) return true;
			// взято из https://github.com/kdmatrosov/validation-codes/blob/master/functions/checkSnils.js
			let value = valueInit.replace(/\D/gu, '');
			const checkSum = parseInt(value.slice(9));
			value = value.substring(0, 9).split('');
			const sum = value.reduce((acc, next, index) => acc + next * (9 - index), 0);

			return (
				(sum < 100 && sum === checkSum) ||
				((sum === 100 || sum === 101) && checkSum === 0) ||
				(sum > 101 && (sum % 101 === checkSum || (sum % 101 === 100 && checkSum === 0)))
			);
		},
		errTextGetter: () => 'Введите корректный СНИЛС',
	},
	widgetTicketAccessAllow: {
		title: 'Виджет ТИКЕТА доступен (часть #1)',
		descr: 'Проверка доступа (в том числе из СПД)',
		func: async (valueInit) => {
			// Проверяем, что valueInit не undefined или null
			if (!valueInit) {
				// Поле не заполнено
				return true;
			}
			try {
				const srcRegex = /<script[^>]*src="([^"]*)"/iu;
				const regexpG = /<script[^>]*src="([^"]*)"/g;
				const arr = Array.from(valueInit.matchAll(regexpG), (m) => m[0]);

				let match = arr[0].match(srcRegex);
				let srcUrl;
				// console.log('match', match);
				if (match && match[1]) {
					srcUrl = match[1];
				} else {
					// console.error('Ссылка не найдена');
					return false;
				}
				let response = await fetch(srcUrl);

				if (!response.ok) {
					// console.log('response.ok', response.url, srcUrl, response);
					throw new Error('Ошибка при загрузке файла', srcUrl);
				}

				if (arr.length === 2) {
					// в цикле await fetch(..) не работает, поэтому так
					match = arr[1].match(srcRegex);
					// console.log('has second script', match);
					if (match && match[1]) {
						srcUrl = match[1];
					} else {
						// console.error('Ссылка не найдена');
						return false;
					}
					response = await fetch(srcUrl);

					if (!response.ok) {
						// console.log('response.ok', response.url, srcUrl, response);
						throw new Error('Ошибка при загрузке файла', srcUrl);
					}
				}

				// Если всё в порядке, возвращаем true
				return true;
			} catch (error) {
				// console.error('widgetTicketAccessAllow: нет доступа', error);
				return false;
			}
		},
		errTextGetter: function (error) {
			// console.log('widgetTicketAccessAllow error:', error);
			return 'Файл недоступен для проверки, проверьте подключение';
		},
	},
	widgetTicketClearCss: {
		/* Временная валидация пока мы даем возможность встраивать скрипты (для виджета тикета) */
		title: 'Виджет ТИКЕТА проверен (часть #2)',
		descr: 'Проверка на наличие запрещённых CSS-правил',
		func: async (valueInit) => {
			// Проверяем, что valueInit не undefined или null
			if (!valueInit) {
				// Поле не заполнено
				return true;
			}
			try {
				const srcRegex = /<script[^>]*src="([^"]*)"/iu;
				const regexpG = /<script[^>]*src="([^"]*)"/g;
				const arr = Array.from(valueInit.matchAll(regexpG), (m) => m[0]);

				let match = arr[0].match(srcRegex);
				let srcUrl;
				if (match && match[1]) {
					srcUrl = match[1];
				} else {
					// console.error('Ссылка не найдена');
					return false;
				}
				let response = await fetch(srcUrl);
				if (!response.ok) {
					throw new Error('Ошибка при загрузке файла');
				}
				const content = await response.text();
				const forbiddenRules = [];
				// Проверка на наличие запрещённых правил
				if (content.includes('*:before, *:after')) {
					forbiddenRules.push('*:before, *:after');
				}
				if (content.includes('*:after, *:before')) {
					forbiddenRules.push('*:after, *:before');
				}
				if (content.includes('h1, h2, h3, h4, h5, h6')) {
					forbiddenRules.push('h1, h2, h3, h4, h5, h6');
				}
				// Если найдены запрещённые правила, возвращаем false
				if (forbiddenRules.length > 0) {
					console.error('Найдены запрещённые CSS-правила:', forbiddenRules);

					return false;
				}

				if (arr.length === 2) {
					// на случай 2х файлов
					match = arr[1].match(srcRegex);
					// console.log('has second script', match);
					if (match && match[1]) {
						srcUrl = match[1];
					} else {
						// console.error('Ссылка не найдена');
						return false;
					}
					response = await fetch(srcUrl);

					if (!response.ok) {
						throw new Error('Ошибка при загрузке файла', srcUrl);
					}
					const content = await response.text();
					const forbiddenRules = [];
					// Проверка на наличие запрещённых правил
					if (content.includes('*:before, *:after')) {
						forbiddenRules.push('*:before, *:after');
					}
					if (content.includes('*:after, *:before')) {
						forbiddenRules.push('*:after, *:before');
					}
					if (content.includes('h1, h2, h3, h4, h5, h6')) {
						forbiddenRules.push('h1, h2, h3, h4, h5, h6');
					}
					// Если найдены запрещённые правила, возвращаем false
					if (forbiddenRules.length > 0) {
						console.error('Найдены запрещённые CSS-правила:', forbiddenRules);

						return false;
					}
				}

				// Если всё в порядке, возвращаем true
				return true;
			} catch (error) {
				// console.error('Ошибка при проверке файла:', error);

				return false;
			}
		},
		errTextGetter: function (error) {
			// console.log('widgetTicketClearCss error:', error);
			return 'В указанном файле присутствует недопустимое CSS свойство';
		},
	},
};

export default {
	methods,
	// ============ Это какие-то регулярки, возможно нигде не используются, или нужны для какой-то магии
	// Закомментил 12.05.23. Если ничего не слмоается, то выпилить
	// regexps: {
	// 	email: {
	// 		regexp: /^([0-9a-zA-Z_]([-+.\w]{0,1}[0-9a-zA-Z_])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/,
	// 		errText: 'Пожалуйста, введите валидный e-mail'
	// 	},
	// 	num_integer: {
	// 		regexp: /^([0-9])+$/,
	// 		errText: 'Пожалуйста, введите целочисленное значение'
	// 	}
	// },
	// ============
	mixin: {
		// именно миксин а не глобальное объявление
		// потому что https://github.com/monterail/vuelidate/issues/302#issuecomment-459329815
		mixins: [validationMixin],
		data() {
			const _validations = {
				value: {},
			};

			const validationRules = this.$props.field_meta.ctrlParams.validationRules;
			if (validationRules) {
				for (const name in validationRules) {
					if (Object.hasOwn(validationRules, name)) {
						const method = methods[name];
						const rule = validationRules[name];

						if (method) {
							// вот тут возможно дороговатая операция - выяснение того принимает ли метод параметры
							// если да - он возвращает функцию
							_validations.value[name] = typeof method.func() === 'function' ? method.func(rule.param) : method.func;
						}
					}
				}
			}

			return {
				_validations,
			};
		},
		validations() {
			return this.$data._validations;
		},
		methods: {
			VALIDATION_ERROR_TEXT() {
				const valState = this.$data._validations.value;
				for (const methodName in valState) {
					if (this.$v.value[methodName] === false) {
						if (methods[methodName].errTextGetter) {
							return methods[methodName].errTextGetter(this.$v.value.$params[methodName]);
						}

						return `Ошибка валидации ${methodName}`;
					} else if (this.$v.value[methodName] !== true) {
						return this.$v.value[methodName];
					}
				}

				return '';
			},
		},
		computed: {
			VALIDATION_ERROR(error) {
				// console.log('error', error);

				return this.$v.value.$invalid;
			},
		},
	},
};
